const {PureComponent} = require("react");
const PropTypes = require("prop-types");
const router = require("app/services/router")

class LazyImg extends PureComponent {

	/////////////////////////////////
	// Init
	/////////////////////////////////

	static get propTypes() {
		return {
			placeholder: PropTypes.string,
			distance: PropTypes.number
		};
	}

	static get defaultProps() {
		return {
			placeholder: `img/lazy_placeholder.png`, //default placeholder image
			distance: 200, //default distance in pixels
			loader: true,
		};
	}

	constructor(props) {
		super(props);

		this.state = {
			loaded: false,
			src: router.url(this.props.placeholder),
			loader: null
		};
	}

	componentWillUnmount() {
		//remove event listener if the component unmounts
		window.removeEventListener('scroll', this.checkVisibility);
	}

	/////////////////////////////////
	// Event Handlers
	/////////////////////////////////

	checkVisibility = () => {

		let elementBox = this.element.getBoundingClientRect();

		if(elementBox.top - window.innerHeight <= this.props.distance){
	
			//Set source of the image
			this.setState({loaded: true});

			//Remove the event listener
			window.removeEventListener('scroll', this.checkVisibility);

		}


	}

	get className() {
		let classList = [];

		if (this.state.loaded) {
			classList.push("active");
		}

		return classList.join(" ");
	}

	render() {
      return (
        <React.Fragment>
          <img
            ref={el => this.element = el}
            className={this.className}
            full={this.props.src}
            alt={this.props.name}
            lazy-load="true"
            afterload={this.props.afterload}
            critical={this.props.critical}
          />

        </React.Fragment>
      );
	}

}

module.exports = LazyImg;
